
/// <amd-module name="Core/Medius.Core.Web/Scripts/components/readonlyTabs/details/prepaymentInvoiceDetails"/>
import * as React from 'react';
import { ContentDivider, FixedGridLayout, InputField, LockedField } from "@medius/ui-controls";
import { translate } from 'Core/Medius.Core.Web/Scripts/lib/globalization';
import { IDocumentImportInformation } from '../interfaces';
import { getBasePath } from 'Core/Medius.Core.Web/Scripts/Medius/lib/path';
import { localizeDate } from '../../prepaymentInvoices/appliedPrepaymentsCommon';
import { getFlagValue, isAnyCustomFieldNotEmpty, isCustomFieldBooleanField1NotEmpty, isCustomFieldCustomListField1NotEmpty, isCustomFieldDateTimeField1NotEmpty, isCustomFieldNumericField1NotEmpty, isCustomFieldTextField1NotEmpty } from './common';

interface PrepaymentInvoiceDetailsProps {
    information: IDocumentImportInformation;
}

export const PrepaymentInvoiceDetails = (props: PrepaymentInvoiceDetailsProps) => {
    return(
        <>
        <FixedGridLayout columns={4}>
            <LockedField
                fieldLabel={translate("#Enterprise/LBL_INVOICE_NUMBER")}
                valueText={props.information?.invoiceNumber}/>
            {props.information?.orderIdentifier && <LockedField
                fieldLabel={translate("#Enterprise/orderIdentifier")}
                valueText={props.information?.orderIdentifier}
            />}
            {props.information?.orderIdentifier2 && <LockedField
                fieldLabel={translate("#Enterprise/orderNumber2")}
                valueText={props.information?.orderIdentifier2}
            />}
            {props.information?.contractNumber && <LockedField
                fieldLabel={translate("#ContractbasedInvoice/contractNumber")}
                valueText={props.information?.contractNumber}
            />}
            <InputField fieldLabel={translate("#Enterprise/supplier")}>
                <a href={`${getBasePath()}#/Administration/Medius.Enterprise.Entities.Supplier/${props.information?.supplierId}`}>{props.information?.supplierName + " (" + props.information?.supplierId + ")"}</a>
            </InputField>
            <InputField fieldLabel={translate("#Core/company")} >
                <a href={`${getBasePath()}#/Administration/Medius.Core.Entities.Company/${props.information?.companyId}`}>{props.information?.companyName + " (" + props.information?.companyId + ")"}</a>
            </InputField>
            <LockedField
                fieldLabel={translate("#Enterprise/invoiceDate")}
                valueText={props.information?.invoiceDate && localizeDate(new Date(props.information?.invoiceDate))}
            />
            <LockedField
                fieldLabel={translate("#OrderbasedInvoice/LBL_DELIVERY_NUMBER")}
                valueText={props.information?.deliveryNote}
            />
            <LockedField
                fieldLabel={translate("#Enterprise/reference")}
                valueText={props.information?.invoiceReference}
            />
            <LockedField
                fieldLabel={translate("#Enterprise/paymentReference")}
                valueText={props.information?.paymentReference}
            />
            <LockedField
                fieldLabel={translate("#Core/document")}
                valueText={props.information?.documentId.toString()}
            />
            <LockedField
                fieldLabel={translate("#Core/createdDate")}
                valueText={props.information?.createDate && localizeDate(new Date(props.information?.createDate))}
            />
            <LockedField
                fieldLabel={translate("#Core/importDate")}
                valueText={props.information?.importDate && localizeDate(new Date(props.information?.importDate))}
            />
            <LockedField
                fieldLabel={translate("#Enterprise/DocumentOriginalFormat")}
                valueText={props.information?.documentOriginalFormat}
            />
            <LockedField
                fieldLabel={translate("#Core/documentSource")}
                valueText={props.information?.documentSource}
            />
            <LockedField
                fieldLabel={translate("#Enterprise/invoiceFormat")}
                valueText={props.information?.documentFormat}
            />
            <LockedField
                fieldLabel={translate("#Enterprise/invoiceProvider")}
                valueText={props.information?.documentProvider}
            />
            <LockedField
                fieldLabel={translate("#Enterprise/referencedDocuments")}
                valueText={props.information?.invoiceReference}
            />
            <LockedField
                fieldLabel={translate("#SupplierStatement/invoiceReconciled")}
                valueText={
                    getFlagValue(props.information?.reconciled)
                }
            />
            <LockedField
                fieldLabel={translate("#Enterprise/straightToArchive")}
                valueText={getFlagValue(props.information?.isStraightToArchive)}
            />
            <LockedField
                fieldLabel={translate("#PurchaseToPay/prepaymentCategory")}
                valueText={props.information?.prepaymentCategory}
            />
        </FixedGridLayout>
        <ContentDivider />
        <FixedGridLayout columns={4}>
            <InputField fieldLabel={translate("#Enterprise/paymentTerm")} >
                <a href={`${getBasePath()}#/Administration/Medius.Enterprise.Entities.PaymentTerm/${props.information?.paymentTermId}`}>{"" + props.information?.paymentTerm + " (" + props.information?.paymentTermId + ")"}</a>
            </InputField>
            {/* uncomment after implementing calculation of dueDate in MFD-61525
            {/* <LockedField
                fieldLabel={translate("#Enterprise/dueDate")}
                valueText={props.information?.dueDate && localizeDate(new Date(props.information?.dueDate))}
            /> */}
            <LockedField
                fieldLabel={translate("#Enterprise/preferredPaymentDate")}
                valueText={props.information?.preferredPaymentDate && localizeDate(new Date(props.information?.preferredPaymentDate))}
            />
        </FixedGridLayout>
        <ContentDivider />
        <FixedGridLayout columns={4}>
            <LockedField
                fieldLabel={translate("#Enterprise/eInvoiceTrackingId")}
                valueText={props.information?.eInvoiceTrackingId}
            />
            <LockedField 
                fieldLabel={translate("#Enterprise/platformAssignedDate")} 
                valueText={props.information?.platformAssignedDate && localizeDate(new Date(props.information?.platformAssignedDate))}
            />
        </FixedGridLayout>
        {isAnyCustomFieldNotEmpty(props.information) && <ContentDivider />}
        {isAnyCustomFieldNotEmpty &&
            <FixedGridLayout columns={4}>
                {isCustomFieldTextField1NotEmpty(props.information) && <LockedField
                    fieldLabel={props.information?.textCustomField1Name}
                    valueText={props.information?.customFieldTextCustomField1}
                />}
                {isCustomFieldNumericField1NotEmpty(props.information) && <LockedField
                    fieldLabel={props.information?.numericCustomField1Name}
                    valueText={props.information?.customFieldNumericCustomField1 && props.information?.customFieldNumericCustomField1.toString()}
                />}
                {isCustomFieldBooleanField1NotEmpty(props.information) && <LockedField
                    fieldLabel={props.information?.booleanCustomField1Name}
                    valueText={getFlagValue(props.information?.customFieldBooleanCustomField1)}
                />}
                {isCustomFieldDateTimeField1NotEmpty(props.information) && <LockedField
                    fieldLabel={props.information?.dateTimeCustomField1Name}
                    valueText={props.information?.customFieldDateTimeCustomField1 && localizeDate(new Date(props.information?.customFieldDateTimeCustomField1))}
                />}
                {isCustomFieldCustomListField1NotEmpty(props.information) && <LockedField
                    fieldLabel={props.information?.listCustomField1Name}
                    valueText={props.information?.customFieldListCustomField1Value}
                />}
            </FixedGridLayout>
            }
        </>
    );
};
